import { useContext } from 'react';
import { StoreContext } from '@ui/context/Store.context';

export const useStore = () => {
    const store = useContext(StoreContext);
    return store;
};
